import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51bae555"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dialog-title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "签署协议")
], -1))
const _hoisted_2 = { class: "dialog-content" }
const _hoisted_3 = { class: "sign-agreement" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "请下载全权委托管理协议，线下完成签署后上传协议", -1))
const _hoisted_6 = { class: "sign-agreement" }

import { reactive, ref } from 'vue'
import { ElMessage } from 'element-plus'
import { CircleCloseFilled } from '@element-plus/icons-vue'
import storage, { StorageType } from '@/utils/storage'
import VerificationCode from '@/components/verification-code/index.vue'
import { downloadFile, fileToBase64 } from '@/utils/index'


export default /*#__PURE__*/_defineComponent({
  __name: 'SignAgreement',
  emits: ['confirm'],
  setup(__props, { expose, emit: emits }) {

const operatorAccount = JSON.parse(
  storage.rcGetItem(StorageType.local, 'userInfo')
)



const uploadRef = ref<any>(null)

const state = reactive({
  loading: false,
  visible: false,
  row: {} as any,
  dialogVisibleFlag: false,
  fileName: '',
  phoneMessage: {
    agreementId: '',
    operatorAccount: '',
    signedEntrustment: ''
  }
})

const verifyCodeConfirm = async () => {
  state.dialogVisibleFlag = false
  state.visible = false
  emits('confirm')
}

const confirm = async () => {
  if (!state.phoneMessage.signedEntrustment) {
    ElMessage.warning('请上传协议')
    return
  }
  state.phoneMessage.agreementId = state.row.id
  state.phoneMessage.operatorAccount = operatorAccount

  state.dialogVisibleFlag = true
}

const customUploadFile = async ({ file }: any) => {
  try {
    if (uploadRef.value) {
      uploadRef.value.clearFiles()
    }
    if (file.type !== 'application/pdf') {
      ElMessage.warning('请上传pdf文件')
      return
    }
    state.loading = true
    const base64: any = await fileToBase64(file)
    state.phoneMessage.signedEntrustment = base64
  } catch (e) {
    console.log(e)
  } finally {
    state.loading = false
  }
}

const downloadAgreement = () => {
  downloadFile(state.row.clientEntrustmentFile, state.row.tradeAccount)
}

const close = () => {
  state.visible = false
  state.phoneMessage.signedEntrustment = ''
}

const removeFile = () => {
  state.phoneMessage.signedEntrustment = ''
}

const open = (row: any) => {
  state.row = row
  state.phoneMessage.signedEntrustment = ''
  state.fileName =
    state.row.clientEntrustmentFile
      .split('?')?.[0]
      ?.split('/')
      ?.slice(-1)?.[0] || ''
  state.visible = true
}

expose({ close, open })

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      modelValue: state.visible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.visible) = $event)),
      width: "500px",
      "destroy-on-close": "",
      center: "",
      "show-close": false
    }, {
      title: _withCtx(() => [
        _hoisted_1
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          class: "content-close",
          onClick: close,
          loading: state.loading
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_el_button, {
          class: "content-confirm",
          onClick: confirm,
          disabled: !state.phoneMessage.signedEntrustment,
          loading: state.loading,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 确定 ")
          ]),
          _: 1
        }, 8, ["disabled", "loading"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _createVNode(_component_el_space, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, "全权委托管理协议" + _toDisplayString(state.fileName), 1),
                  _createVNode(_component_el_button, {
                    type: "text",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (downloadAgreement()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("下载")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _hoisted_5
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          (!state.phoneMessage.signedEntrustment)
            ? (_openBlock(), _createBlock(_component_el_upload, {
                key: 0,
                ref_key: "uploadRef",
                ref: uploadRef,
                action: "",
                accept: "application/pdf",
                limit: 1,
                disabled: state.loading,
                "show-file-list": false,
                "http-request": customUploadFile
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    loading: state.loading
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("+上传协议")
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ]),
                _: 1
              }, 8, ["disabled"]))
            : (_openBlock(), _createBlock(_component_el_space, { key: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "text",
                    class: "tips"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("协议文件已上传 ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_icon, { onClick: removeFile }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(CircleCloseFilled), { color: "#999" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(VerificationCode, {
      dialogVisible: state.dialogVisibleFlag,
      "onUpdate:dialogVisible": _cache[2] || (_cache[2] = ($event: any) => ((state.dialogVisibleFlag) = $event)),
      phoneMessage: state.phoneMessage,
      onConfirm: verifyCodeConfirm
    }, null, 8, ["dialogVisible", "phoneMessage"])
  ], 64))
}
}

})